export enum sortList {
    City = 0,
    Country = 1,
    Name = 2,
    Status = 3,
    CreationDate = 4
}
